// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__YO7J6","total":"Cart_total__F-EkC","info":"Cart_info__NT3CF","ordered":"Cart_ordered__v4jDd"};